<template>
  <header class="header">
    <div class="navigation">
      <div class="container-left">
        <AppLauncherButton />

        <div v-if="isLoaded" class="company">
          <router-link :to="{ name: ROUTE_ROOT }">
            <OptimizedImage
              class="company__logo"
              :src="activeSession.logo_url"
              :title="$t('navigation.GO_TO_START_PAGE')"
              :aria-label="$t('navigation.GO_TO_START_PAGE')"
              alt="Company logo"
              sizes="200px"
            />
          </router-link>
        </div>
      </div>

      <div class="breadcrumbs--desktop">
        <Breadcrumbs />
      </div>

      <!-- Custom slot -->
      <span>
        <slot />
      </span>
    </div>

    <HeaderMenu class="menu-button" />
  </header>
</template>

<script setup lang="ts">
import AppLauncherButton from '@/components/generics/AppLauncherButton.vue'
import OptimizedImage from '@/components/generics/OptimizedImage/OptimizedImage.vue'
import Breadcrumbs from '@/components/layout/breadcrumbs/Breadcrumbs.vue'
import HeaderMenu from '@/components/layout/header/HeaderMenu.vue'
import { useState } from '@/hooks/vue-utils/useVuex'
import { ROUTE_ROOT } from '@/router/routes/routeNames'
import * as SessionApi from '@attensi/session'
import { onMounted, ref } from 'vue'

const { currentCompanyLoaded } = useState('common', ['currentCompanyLoaded'])

const activeSession = ref<SessionApi.AttensiSession | undefined>(undefined)
const sessions = ref<SessionApi.AttensiSession[] | undefined>(undefined)
const isLoaded = ref<boolean>(false)

onMounted(async () => {
  sessions.value = await SessionApi.getSessions()
  activeSession.value = await SessionApi.getActiveSession()
  isLoaded.value = Boolean(activeSession.value && currentCompanyLoaded)
})
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: $header-height;
  background: $color-canvas;
  border-bottom: 1px solid $color-border; // sticky scroll leaves gap. (needs to be recalculated)
  z-index: $base-header-z-index;
  position: sticky;
  top: 0;

  @media screen and (max-width: $tablet-width-max) {
    height: $header-mobile-height;
  }
}

.navigation {
  display: flex;
  align-items: center;
  flex: 1 1 100%;
}

.container-left {
  display: flex;
  align-items: center;
  gap: $spacing-3xs;
  width: $master-layout-sidebar-width-desktop;
  padding-left: $spacing-2xs;
  border-right: 1px solid $color-border;

  @media screen and (max-width: $tablet-width-max) {
    gap: $spacing-3xs;
    padding-left: $spacing-5xs;
  }
}

.breadcrumbs--desktop {
  margin-left: $pageHorizontalMargin;
}

.company {
  all: unset;
  position: relative;
  text-align: center;
  cursor: pointer;

  &__logo {
    object-fit: contain;
    height: $spacing-l;
    aspect-ratio: 3.8;

    @media screen and (max-width: $tablet-width-max) {
      height: 30px;
    }
  }
}

.menu-button {
  align-self: stretch;
  margin: $spacing-5xs $spacing-xs $spacing-5xs 0;
}

@media screen and (max-width: $tablet-width-max) {
  .header {
    padding-right: 0px;
  }

  .container-left {
    justify-content: unset;
  }

  .breadcrumbs--desktop {
    display: none;
  }
}

@media screen and (max-width: $mobile-width-max) {
  .menu-button {
    margin: 0 $spacing-3xs 0 0px;
  }
}
</style>
